<script>
// Note how there's no template or styles in this component.

// Helper functions to convert a percentage of canvas area to pixels.
const percentWidthToPix = (percent, ctx) => Math.max(Math.floor((ctx.canvas.width / 100) * percent), 0)

const percentHeightToPix = (percent, ctx) => Math.max(Math.floor((ctx.canvas.height / 100) * percent), 0)

export default {
  // Gets us the provider property from the parent <my-canvas> component.
  inject: ['provider'],

  props: {
    // Start coordinates (percentage of canvas dimensions).
    x1: {
      type: Number,
      default: 0
    },
    y1: {
      type: Number,
      default: 0
    },

    // End coordinates (percentage of canvas dimensions).
    x2: {
      type: Number,
      default: 0
    },
    y2: {
      type: Number,
      default: 0
    },

    // The value to display.
    value: {
      type: Number,
      default: 0
    },

    status: {
      type: String,
      default: ''
    }

    // // The color of the box.
    // color: {
    //   type: String,
    //   default: '#F00'
    // }
  },

  data () {
    return {
      // We cache the dimensions of the previous
      // render so that we can clear the area later.
      oldBox: {
        x: null,
        y: null,
        w: null,
        h: null
      },
      tempx2: 0
    }
  },

  created() {
      var that = this;

      setInterval(() => {
        // if (that.x2 != that.tempx2) {
          if (Math.abs(that.x2 - that.tempx2) < 3) {
            that.tempx2 = that.x2;
          } else if (that.x2 > that.tempx2) {
            that.tempx2 += 3;
          } else {
            that.tempx2 -= 3;
          }
        // }
        // that.x2 = that.x2 + 5;
        // that.calculatedBox
        // console.log('hello')

      }, 100);
  },

  computed: {
    calculatedBox () {
      const ctx = this.provider.context

      // Turn start / end percentages into x, y, width, height in pixels.
      const calculated = {
        x: percentWidthToPix(this.x1, ctx),
        y: percentHeightToPix(this.y1, ctx),
        w: percentWidthToPix(this.tempx2 - this.x1, ctx),
        h: percentHeightToPix((this.y2 - this.y1) / 1.5, ctx)
      }

      // Yes yes, side-effects. This lets us cache the box dimensions of the previous render.
      // before we re-calculate calculatedBox the next render.
      this.oldBox = calculated
      return calculated


    }
  },

  render () {
    // Since the parent canvas has to mount first, it's *possible* that the context may not be
    // injected by the time this render function runs the first time.
    if(!this.provider.context) return;
    const ctx = this.provider.context;

    // Keep a reference to the box used in the previous render call.
    const oldBox = this.oldBox
    // Calculate the new box. (Computed properties update on-demand.)
    const newBox = this.calculatedBox

    ctx.beginPath();
    // Clear the old area from the previous render.
    ctx.clearRect(oldBox.x, oldBox.y, oldBox.w, oldBox.h);
    // Clear the area for the text.
    // ctx.clearRect(newBox.x, newBox.y - 42, newBox.w, 100);

    /* radius rect */
    
    CanvasRenderingContext2D.prototype.roundRect = function (x, y, width, height, radius) {
      if (width < 2 * radius) radius = Math.abs(width / 2);
      if (height < 2 * radius) radius = Math.abs(height / 2);
      this.beginPath();
      this.moveTo(x + radius, y);
      this.arcTo(x + width, y, x + width, y + height, radius);
      this.arcTo(x + width, y + height, x, y + height, radius);
      this.arcTo(x, y + height, x, y, radius);
      this.arcTo(x, y, x + width, y, radius);
      this.closePath();
      return this;
    }
    ctx.roundRect(newBox.x, newBox.y, newBox.w, newBox.h, 15);
    
    // Draw the new rectangle.
    // ctx.rect(newBox.x, newBox.y, newBox.w, newBox.h);

    
    var my_gradient = ctx.createLinearGradient(0, 0, 0, 210); // add gradient 

    if (this.status === "Disconnected") {
      my_gradient.addColorStop(0, "#777777");
    } else {
      if (this.x2 > 80) {
       // ctx.fillStyle = '#da291c'; /* red */
        my_gradient.addColorStop(0, "#da291c");  // add gradient 
      } else if (this.x2 > 60) {
        my_gradient.addColorStop(0, "#FE8F1D");  // add gradient 
        //ctx.fillStyle = '#FE8F1D'; /*orange */
      } else if (this.x2 > 40) {
        //ctx.fillStyle = '#fce300'; /*yellow*/
         my_gradient.addColorStop(0, "#fce300"); // add gradient 
      } else {
         my_gradient.addColorStop(0, "#00635B"); // add gradient 
        //ctx.fillStyle = '#00635B'; /*green */
      }
    }


    my_gradient.addColorStop(1, "white"); // add gradient
    ctx.fillStyle = my_gradient;  // add gradient 
    ctx.fill();

    // Draw the text
    ctx.fillStyle = '#000'
    ctx.font = '28px sans-serif';
    ctx.textAlign = 'center';
    //ctx.fillText(Math.floor(this.value), (newBox.x + (newBox.w / 2)), newBox.y - 14)
  }
}
</script>
